import { serviceTaskSolutionsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("service-task-solutions"),
  endpoint: "service-task-solutions",
  operations: serviceTaskSolutionsOps,
  roleView: [ROLE.SC_TASK_CATEGORY_VIEW, ROLE.SC_TASK_CATEGORY_ADMIN],
  roleAdmin: [ROLE.SC_TASK_CATEGORY_ADMIN],
  singularName: (t) => t("Service task solution"),
  name: (t) => t("Service task solutions"),
  syncCustomerFilter: true,
  dependencies: ["service-task"],
  sendCulture: true,
});
export default conf;
